export default "__VITE_ASSET__974bb675__"